import { createSlice } from '@reduxjs/toolkit';
import type { RootState } from './store';

export type authStateType = {
  email?: string;
  password?: string;
  fullName?: string;
  firstName?: string;
  lastName?: string;
  rememberMe: boolean;
  isSignIn?: boolean;
  isFirstLogin?: boolean;
  isAuthenticated?: boolean;
  permissions?: string[];
};

const initialState: authStateType = {
  email: '',
  password: '',
  fullName: '',
  firstName: '',
  lastName: '',
  rememberMe: false,
  isSignIn: false,
  isFirstLogin: false,
  isAuthenticated: false,
  permissions: []
};

export const authStateSlice = createSlice({
  name: 'authStateSlice',
  initialState,
  reducers: {
    setSignUpData: (state, action) => {
      const { email, password, fullName, firstName, lastName, isSignIn } =
        action.payload;
      state.email = email;
      state.password = password;
      state.firstName = firstName;
      state.lastName = lastName;
      state.fullName = fullName;
      state.isSignIn = isSignIn;
      return state;
    },
    setRememberMe: (state, action) => {
      state.rememberMe = action.payload.rememberMe;
    },
    setFirstLogin: (state, action) => {
      state.isFirstLogin = action.payload.isFirstLogin;
    },
    setIsAuthenticated: (state, action) => {
      state.isAuthenticated = action.payload.isAuthenticated;
    },
    resetAuthState: () => {
      return initialState;
    },
    setPermissions: (state, action) => {
      state.permissions = action.payload.permissions;
    }
  }
});

export const {
  setSignUpData,
  setRememberMe,
  setFirstLogin,
  setIsAuthenticated,
  resetAuthState,
  setPermissions
} = authStateSlice.actions;

export const getSignUpData = (state: RootState) => state.authStateSlice;
export const getRememberMe = (state: RootState) =>
  state.authStateSlice.rememberMe;
export const getFirstLogin = (state: RootState) =>
  state.authStateSlice.isFirstLogin;
export const getIsAuthenticated = (state: RootState) =>
  state.authStateSlice.isAuthenticated;
export const getPermissions = (state: RootState) =>
  state.authStateSlice.permissions;
